import Typography from "@mui/material/Typography";
import {Grid} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {Link as RouterLink} from "react-router-dom";
import {RoutePaths} from "../../../util/constants";
import {RootState, useAppSelector} from "../../../store";

const LetsBegin = () => {
    const {t} = useTranslation()
    const isLoggedIn = useAppSelector((state: RootState) => !!state.authReducer.loggedInUser.id)
    const promoPoints = useAppSelector((state: RootState) => state.appReducer.featureToggles.promo_points)

    return (
        <Box textAlign="center" mt={8}>
            <Typography variant="h4" fontWeight={600} color="primary">
                {t('lets_begin')}
            </Typography>

            <Grid container spacing={3} mt={2}>
                <Grid item xs={12} sm={6} justifyContent="center">
                    <Box display="flex" justifyContent="center" mb={2}>
                        <Typography variant="h5" fontWeight={600} color="primary" maxWidth={280}>
                            {isLoggedIn ? t('start_wishing') : !promoPoints.value ?
                                t('register_now_and_start_wishing') :
                                t('start_and_free_points', {points: promoPoints.points})}
                        </Typography>
                    </Box>

                    <Button variant="contained" component={RouterLink}
                            to={!isLoggedIn ? RoutePaths.AUTH : RoutePaths.WISHES}>
                        {isLoggedIn ? t('wishes') : t('register')}
                    </Button>
                </Grid>

                <Grid item xs={12} sm={6} justifyContent="center">
                    <Box display="flex" justifyContent="center" mb={2}>
                        <Typography variant="h5" fontWeight={600} color="primary" maxWidth={280}>
                            {t('learn_more_rules')}
                        </Typography>
                    </Box>

                    <Button variant="contained" component={RouterLink} to={RoutePaths.TERMS}>
                        {t('terms')}
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={3} justifyContent="center" mt={0}>
                <Grid item xs={12} sm={4} justifyContent="center">
                    <Box display="flex" justifyContent="center" mb={2}>
                        <Typography variant="h5" fontWeight={600} color="primary" maxWidth={280}>
                            {t('discover_guide_text')}
                        </Typography>
                    </Box>

                    <Button variant="contained" component={RouterLink} to={RoutePaths.GUIDE}>
                        {t('guide')}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}

export default LetsBegin
